import WidgetBase from '../widget.base';

export default class AugmentedRealityExperience extends WidgetBase {
    static selector = '[data-js-module="augmented-reality-experience"]';

    constructor(el) {
        super(el);

        const {
            androidFile,
            androidAudioFile,
            autoPlay,
            augmentedRealityExperienceName,
            iosFile
        } = this.el.dataset;
        const androidFullUrl = `intent://arvr.google.com/scene-viewer/1.0?file=${androidFile}&mode=ar_preferred${(androidAudioFile) ? `&sound=${androidAudioFile}` : ''}#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=https://developers.google.com/ar;end;`;
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const triggerQuery = `[data-augmented-reality-experience-link='${augmentedRealityExperienceName}']`;
        let canAutoPlay = document.querySelectorAll(`[data-js-module="augmented-reality-experience"]:not([data-augmented-reality-experience-name='${augmentedRealityExperienceName}'])`).length === 0;

        this.$triggers = document.querySelectorAll(triggerQuery);

        if (/android/i.test(userAgent)) {
            this.setupExperience(androidFullUrl);
        }
        else if (/Mac/i.test(userAgent) && !window.MSStream) {
            this.setupExperience(iosFile, true);
        }
        else {
            this.setupFallbackExperience();
            canAutoPlay = false;
        }

        if (canAutoPlay && autoPlay === 'true') {
            this.$triggers[0].click();
        }

        setTimeout(() => {
            this.loaded();
        });
    }

    setupExperience(url, setRel) {
        const { $triggers } = this;

        $triggers.forEach((trigger) => {
            if (setRel) {
                trigger.setAttribute('rel', 'ar');
            }

            trigger.setAttribute('href', url);
        });
    }

    setupFallbackExperience() {
        const { $triggers } = this;

        $triggers.forEach((trigger) => {
            trigger.classList.add('disabled');
            trigger.setAttribute('title', 'Your device does not support AR at this time.');

            trigger.addEventListener('click', e => e.preventDefault());
        });
    }
}
